"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('mask-one', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("path", {
    d: "M7.36573 16.3446C6.48571 18.7026 6 21.2883 6 24C6 26.7117 6.48571 29.2974 7.36573 31.6554M11.2721 38.1421C12.9301 39.9844 14.91 41.4689 17.1101 42.4825C19.2324 43.4603 21.5595 44 24 44C26.4405 44 28.7676 43.4603 30.8899 42.4825C33.09 41.4689 35.0699 39.9844 36.7279 38.1421M40.6343 31.6554C41.5143 29.2974 42 26.7117 42 24C42 21.2883 41.5143 18.7026 40.6343 16.3446M36.7279 9.85786C35.0699 8.01564 33.09 6.53113 30.8899 5.51747C28.7676 4.53967 26.4405 4 24 4C19.0294 4 14.5294 6.23858 11.2721 9.85786",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap
  }), _react.default.createElement("path", {
    d: "M18 23C19.6569 23 21 21.6569 21 20C21 18.3431 19.6569 17 18 17C16.3431 17 15 18.3431 15 20C15 21.6569 16.3431 23 18 23Z",
    fill: props.outFillColor,
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth
  }), _react.default.createElement("path", {
    d: "M30 23C31.6569 23 33 21.6569 33 20C33 18.3431 31.6569 17 30 17C28.3431 17 27 18.3431 27 20C27 21.6569 28.3431 23 30 23Z",
    fill: props.outFillColor,
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth
  }), _react.default.createElement("path", {
    d: "M24 35C26.7614 35 29 33.6569 29 32C29 30.3431 26.7614 29 24 29C21.2386 29 19 30.3431 19 32C19 33.6569 21.2386 35 24 35Z",
    fill: props.outFillColor,
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth
  }));
});

exports.default = _default;